import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import getGqlClient from '../graphql/client';
import getTenantTypeQuery from '../graphql/queries/tenantType';

const TenantTypeContext = React.createContext();

export const TenantTypeProvider = ({ children }) => {
  const [tenantType, setTenantType] = useState(null);

  useEffect(() => {
    const requestTenantType = async () => {
      try {
        const tenantTypeResponse = await getTenantTypeQuery(getGqlClient());
        setTenantType(tenantTypeResponse);
      } catch (error) {
        console.error(error);
      }
    };

    requestTenantType();
  }, []);

  return (
    <TenantTypeContext.Provider value={{ tenantType }}>
      {children}
    </TenantTypeContext.Provider>
  );
};

TenantTypeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export const useTenantTypeContext = () => useContext(TenantTypeContext);
export const TenantTypeProviderConsumer = TenantTypeContext.Consumer;

export default {
  TenantTypeProvider,
  TenantTypeProviderConsumer,
  useTenantTypeContext
};
